import { situacaoSignatarioDocumentoProcessoDigital } from '@/core/constants'

export default {
	methods: {
		getCorIconeSituacaoSignatario(situacao) {
			switch (situacao) {
				case situacaoSignatarioDocumentoProcessoDigital.ASSINADO.value:
					return 'success'
				case situacaoSignatarioDocumentoProcessoDigital.ENVIADO.value:
					return 'warning'
				case situacaoSignatarioDocumentoProcessoDigital.EXPIRADO.value:
					return 'light-blue'
				default:
					return 'error'
			}
		},
		getIconeSituacaoSignatario(situacao) {
			switch (situacao) {
				case situacaoSignatarioDocumentoProcessoDigital.ASSINADO.value:
					return 'mdi-check'
				case situacaoSignatarioDocumentoProcessoDigital.EXPIRADO.value:
					return 'mdi-timer-off'
				default:
					return 'mdi-clock-outline'
			}
		},
	},
}
